<template>
  <div class="a-back-to-top__wrapper">
    <fade-transition>
      <div v-if="isButtonVisible">
        <div v-focusable class="a-back-to-top" @click="scrollToTop">
          <a-icon
            :icon="$options.consts.ICON.ARROW_UP_WHITE"
            original
            :height="8"
            :width="12"
          />
        </div>
      </div>
    </fade-transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AIcon, { ICON } from 'shared/AIcon'
import { hydrationHelpers } from '@/utils/mixins/hydrationHelpers'

export default {
  name: 'ABackToTopButton',
  mixins: [hydrationHelpers],
  components: { AIcon },
  consts: {
    ICON,
    SCROLL_BREAKPOINT: 1500
  },
  computed: {
    ...mapGetters({
      scrollTop: 'scrollTop'
    }),
    isButtonVisible() {
      return (
        this.scrollTop > this.$options.consts.SCROLL_BREAKPOINT &&
        this.$_hydrationHelpers_isLayoutMobile
      )
    }
  },
  methods: {
    scrollToTop() {
      this.$scrollTo('body', 500)
    }
  }
}
</script>

<style lang="scss" scoped>
.a-back-to-top__wrapper {
  position: fixed;
  bottom: 70px;
  right: 12px;
  z-index: $z-index-back-to-top-button;

  .a-back-to-top {
    background: $c--main;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
